import { Const } from '../lib/const.cls'

export const getters = {
	//-------------------------------------Subscription data------------------------------------
	[Const.GET_SUBSCRIPTION_LIST]: (state) => {
		return state.subscriptionData
	},
	[Const.GET_GROSS_INCOME_LIST]: (state) => {
		return state.grossIncomeData
	},

	[Const.GET_SUBSCRIPTION_DETAIL]: (state) => {
		return state.subscriptionDetail
	},
	//------------------------------------------------------------listing----------------------------------------------------------
	[Const.GET_LEAD_USER_LISTING]: (state) => {											
		return state.leadUserListing
	},
	[Const.GET_KYC_USER_LISTING]: (state) => {											
		return state.kycUserListing
	},

	[Const.GET_CVL_RESPONSE]: (state) => {											
		return state.cvlResponse
	},

	[Const.GET_CVL_STATUS]: (state) => {											
		return state.cvlStatus
	},

	[Const.GET_USER_PAN_ATTEMPT_LIST]: (state) => {											
		return state.userPanAttemptList
	},

	[Const.GET_USER_LIST_FOR_SQUADIQ]: (state) => {											
		return state.userListForSquadiq
	},
	[Const.GET_ADMIN_CHART_DATA]: (state) => {											
		return state.Chartdata
	},
	[Const.GET_ADMIN_DEPOSIT_DATA]: (state) => {											
		return state.Depositchart
	},
	[Const.GET_ADMIN_WITHDRAWAL_DATA]: (state) => {											
		return state.Withdrawalchart
	},
	[Const.GET_ADMIN_REGISTRATION_LINE_DATA]: (state) => {											
		return state.Chartlinedata
	},
	[Const.GET_API_KEY_LIST]: (state) => {											
		return state.apiKeyData
	},
	//------------------------------------------------------------adminReferredList----------------------------------------------------------
	[Const.GET_ADMIN_REFERRED_LIST]: (state) => {											
		return state.adminReferredList
	},

	[Const.GET_XML_DOWALOAD_DOC_URL]: (state) => {											
		return state.xmlDownload_doc_url
	},

	[Const.GET_PAN_DATA]: (state) => {											
		return state.panData
	},
	[Const.GET_ROLES_LIST]: (state) => {											
		return state.rolesList
	},
	[Const.GET_LOCK_UNLOCK_DATA]: (state) => {											
		return state.get_lock_unlock_data
	},
	[Const.GET_RISING_RECONCILATION_LIST]: (state) => {											
		return state.rising_reconcilation_list
	},
	[Const.GET_DEBIT_LIST]: (state) => {											
		return state.debit_list
	},
	[Const.GET_ADMIN_USER_LISTING]: (state) => {											
		return state.admin_user_list
	},
	[Const.GET_XML_DOC_URL]: (state) => {											
		return state.xml_doc_url
	},
	[Const.GET_SUPPORT_LIST]: (state) => {											
		return state.support_list
	},
	[Const.GET_DEMAT_PENDING_LIST]: (state) => {											
		return state.demat_pending_list
	},
	[Const.GET_CATEGORISATION_USER_LIST]: (state) => {											
		return state.categorisation_list
	},
	[Const.GET_STAGGING_RISING_LIST]: (state) => {											
		return state.stagging_rising_list
	},
	[Const.GET_STAGGING_RISING_LIST_CSV]: (state) => {											
		return state.stagging_rising_list_csv
	},
	//------------------------------------------------------------view------------------------------------------------------------
	[Const.GET_SUPPORT_VIEW]: (state) => {											
		return state.support_view
	},
	[Const.GET_SUPPORT_DOCS]: (state) => {											
		return state.support_view_doc
	},
	[Const.GET_VIEW_ADMIN_USER_DETAIL]: (state) => {											
		return state.admin_view_user_detail
	},
	[Const.GET_ADMIN_PRIVILEDGES_ASSIGN_LIST]: (state) => {											
		return state.admin_priviledges_assign_list
	},
	[Const.GET_DASHBOARD_DATA]: (state) => {											
		return state.dashboard_data
	},
	[Const.GET_NEW_REGISTERATIONS]: (state) => {							
		return state.new_reg
	},
	[Const.GET_CATEGORISATION_USER_DETAIL]: (state) => {							
		return state.categorisation_detail
	},
	[Const.GET_REASON_LIST]: (state) => {							
		return state.reason_list
	},
	//----------------------------------------------------dropdown through api hit--------------------------------------------------------
	[Const.GET_SUPPORT_REASON_LIST]: (state) => {
		return state.support_reason_list
	},
	//----------------------------------------------------dropdown through local state variable------------------------------
	[Const.GET_BANK_LIST]: (state) => {
		return state.bank_list
	},
	[Const.GET_ACCOUNT_TYPE_LIST]: (state) => {
		return state.account_type_list
	},
	[Const.GET_STATE_LIST]: (state) => {
		return state.state_list
	},
	[Const.GET_KS_STATE_LIST]: (state) => {
		return state.ks_state_list
	},
	[Const.GET_CITY_LIST]: (state) => {
		return state.city_list
	},
	[Const.GET_COUNTRY_LIST]: (state) => {
		return state.country_list
	},
	[Const.GET_KS_COUNTRY_LIST]: (state) => {
		return state.ks_country_list
	},
	[Const.GET_SEGMENT_LIST]: (state) => {
		return state.segment_list
	},
	[Const.GET_HOLD_REASON_LIST]: (state) => {
		return state.hold_reason_list
	},
	[Const.GET_STEP_INFORMATION_LIST]: (state) => {
		return state.step_information_list
	},
	[Const.GET_RESIDENT_LIST]: (state) => {
		return state.resident_list
	},
	[Const.GET_GENDER_LIST]: (state) => {
		return state.gender_list
	},
	[Const.GET_PAYMENT_METHOD_LIST]: (state) => {
		return state.payment_method_list
	},
	[Const.GET_ONBOARDING_SOURCE_LIST]: (state) => {
		return state.onboarding_source_list
	},
	[Const.GET_INCOME_PROOF_STATUS_LIST]: (state) => {
		return state.income_proof_status_list
	},
	[Const.GET_NATIONALITY_DATA]: (state) => {											// profile page
		return state.nationality_list
	},
	[Const.GET_MATRIAL_DATA]: (state) => {											// profile page
		return state.matrial_status_list
	},
	[Const.GET_KS_MATRIAL_DATA]: (state) => {											// profile page
		return state.ks_matrial_status_list
	},
	[Const.GET_OCCUPATION_LIST]: (state) => {
	return state.occupation_list
	},
	[Const.GET_KS_OCCUPATION_LIST]: (state) => {
	return state.ks_occupation_list
	},
	[Const.GET_INCOME_LIST]: (state) => {
	return state.income_list
	},
	[Const.GET_ADDRESS_PROOF_LIST]: (state) => {
	return state.address_proof_list
	},
	[Const.GET_KS_ADDRESS_PROOF_LIST]: (state) => {
	return state.ks_address_proof_list
	},
	[Const.GET_ADDRESS_TYPE_LIST]: (state) => {
	return state.address_type_list
	},
	[Const.GET_KS_ADDRESS_TYPE_LIST]: (state) => {
	return state.ks_address_type_list
	},
	//------------------------------------------------------------document url-----------------------------------------------------
	[Const.GET_USER_DOCUMENT_URL]: (state) => {
		return state.user_document_url
	},
	[Const.GET_SPLITTER_DOCUMENT_URL]: (state) => {
		return state.rms_splitter_url
	},
	[Const.GET_CVL_DOCUMENT_URL]: (state) => {
		return state.cvl_document_url
	},
	[Const.GET_TICKET_DOCUMENT_URL]: (state) => {
		return state.ticket_doc_url
	},
	[Const.GET_PDF_DOCUMENT_URL]: (state) => {
		return state.pdf_doc_url
	},

	//----------------------------------------knowledge--------------------------------------

	[Const.GET_CAT_LIST]: (state) => {
		return state.catList
	},

	[Const.GET_ARTICLE_LIST]: (state) => {
		return state.articleList
	},
	[Const.GET_CVL_STATUS_LIST]: (state) => {
		return state.cvlStatusList
	},
	[Const.GET_SPLITTER_LIST]: (state) => {
		return state.rmsSplitterList
	},
	[Const.GET_CVL_RESPONSE_LIST]: (state) => {
		return state.cvlResponseList
	},
	//-------------------------------------nominee data------------------------------------
	[Const.GET_USERS_LIST_FOR_NOMINEE]: (state) => {
		return state.UserslistForNominee
	},

	[Const.GET_NOMINEE_DETAIL]: (state) => {
		return state.NomineeDetail
	},
}



// WEBPACK FOOTER //
// ./src/plugins/prism_admin/provider/candle-history/store-addons/getters.js